export default __webpack_public_path__ + "static/media/sudarshan-img1.c6e9fac5.jpg";